import { render, staticRenderFns } from "./WithdrawModal.vue?vue&type=template&id=728a4782&scoped=true"
import script from "./WithdrawModal.vue?vue&type=script&lang=js"
export * from "./WithdrawModal.vue?vue&type=script&lang=js"
import style0 from "./WithdrawModal.vue?vue&type=style&index=0&id=728a4782&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728a4782",
  null
  
)

export default component.exports